<template v-slot:activator="{on}">
  <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
    <template v-slot:activator="{ on, attrs }">
        <v-btn v-on="on" v-bind="attrs" class="primary mt-3" large text dark to="#">See The Tech</v-btn>
    </template>
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="dialog = false">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title class="dialog-title">She Platform's Tech</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn class="close-btn" dark text @click="dialog = false">close</v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-list>
          <v-card :key="tech.title" v-for="tech in techs" class="ma-3" raised>  
            <v-card-title primary-title>
              <div>
                <h3 :class="`${tech.class}--text`" class="headline mb-0 platform--header">{{tech.title}}</h3>
                <div>{{tech.description}}</div>
              </div>
            </v-card-title>
          </v-card>
          </v-list>       
        </v-card>
      </v-dialog>
</template>

<script>
export default {
  data () {
      return {
        dialog: false,
        techs: [
          {
            class: 'nft',
            title: 'Non Fungible Tokens',
            description: 'In She\'s NFT marketplace powered by the Binance Smart Chain.'
          },
          {
            class: 'voice',
            title: 'Artificial Intelligence',
            description: 'The world\'s first fashion AI provides fashion suggestions based on an individual user\'s style.'
          },
          {
            class: 'connect',
            title: 'Internet of Things',
            description: 'From microscopic lenses verifying condition to scannable manufacturer tags to ensure authenticity.'
          },
          {
            class: 'verify',
            title: 'Crowd Verification',
            description: 'A staked reputation system where users hold stock in the entities they review.'
          },
          {
            class: 'academy',
            title: 'Decentralized Applications',
            description: 'Democratizing both retail purchases and bartering in the women\'s clothing space.'
          },
        ]
      }
    }
}
</script>

<style>
.platform--header {
    font-family: "Baloo", sans-serif !important;
    font-size: 20px;
    text-transform: none !important;
    font-weight: 400;
}
.v-dialog__content {
  z-index: 9999 !important;
}
.v-list--three-line .v-list__tile {
    height: auto;
    padding-top: 15px;
}
</style>
